<template>
    <div class="container-fluid form-container elighting-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    E-lighting Form
                </h1>
            </div>
        </div>
        <form
            action=""
            class="elighting-form"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Job Details</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged"
                            >
                                <option value="">
                                    Select Site
                                </option>
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="service_report_no">Emergency Lighting Service Report Number</label>
                            <input
                                type="text"
                                id="service_report_no"
                                name="service_report_no"
                                v-model="form.service_report_no"
                                placeholder="Fire Alarm Service Report Number"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="service_report_no"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-3">
                            <label
                                for="service_time"
                                class="label"
                            >How long did this service take?</label>
                        </div>
                        <div class="col-sm-12 col-md-2">
                            <duration-select-component
                                v-model="form.elighting_service_time"
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>

            <job-info
                v-if="form.job_id"
                :job-id="form.job_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>General</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label for="signing_in_process">Have you already completed signing in
                                            process?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.signing_in_process"
                                            class="form-control"
                                        >
                                            <option>Yes - Fire Alarm Form</option>
                                            <option>Yes - Fire Ex Form</option>
                                            <option>No</option>
                                        </select>
                                        <error
                                            name="signing_in_process"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                                <tr v-if="form.signing_in_process === 'No'">
                                    <td>
                                        <label for="signed_in">Have You Signed In?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.signed_in"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>Not Required or Asked</option>
                                            <option>Non Manned</option>
                                        </select>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr v-if="form.signing_in_process === 'No'">
                                    <td>
                                        <label for="require_rams">Does the customer require our RAMS?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="require_rams"
                                            v-model="form.require_rams"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signed_in"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr v-if="form.signing_in_process === 'No'">
                                    <td>
                                        <label for="risk_assessment">Is there a fire risk assessment on site and has it
                                            been reviewed in the last 12 months?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.risk_assessment"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>No Assessment on site</option>
                                            <option>Assessment not available</option>
                                            <option>R.P not on site</option>
                                            <option>Non manned</option>
                                            <option>Customer would like quotation</option>
                                            <option>I was not requested to check the site Fire Risk Assessment</option>
                                        </select>
                                        <error
                                            name="risk_assessment"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr v-if="form.signing_in_process === 'No'">
                                    <td>
                                        <label for="action_points">Have all relevant action points been
                                            resolved?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="action_points"
                                            v-model="form.action_points"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="action_points"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr v-if="form.signing_in_process === 'No'">
                                    <td>
                                        <label for="asbestos_report">Have you checked and reviewed the asbestos report
                                            before works are being carried out?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="asbestos_report"
                                            v-model="form.asbestos_report"
                                            value="N/A"
                                        > N/A</label>
                                        <error
                                            name="asbestos_report"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Property Emergency Lighting Test</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table
                                class="table lighting-table"
                                id="lights-table"
                            >
                                <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th
                                            class="th td td-sw-no"
                                            @click.prevent="sortLights('sw_no')"
                                            :class="sortClass('sw_no')"
                                        >
                                            T.S No
                                        </th>
                                        <th
                                            class="th td td-light-no"
                                            @click.prevent="sortLights('light_no')"
                                            :class="sortClass('light_no')"
                                        >
                                            Li No
                                        </th>
                                        <th
                                            class="th td td-maintained"
                                            @click.prevent="sortLights('maintained')"
                                            :class="sortClass('maintained')"
                                        >
                                            Main
                                        </th>
                                        <th
                                            class="th td td-type"
                                            @click.prevent="sortLights('type')"
                                            :class="sortClass('type')"
                                        >
                                            Type
                                        </th>
                                        <th
                                            class="th td td-location-light"
                                            @click.prevent="sortLights('light_location')"
                                            :class="sortClass('light_location')"
                                        >
                                            Location
                                        </th>
                                        <th class="th td td-high text-center">
                                            High
                                        </th>
                                        <th
                                            class="th td td-tested"
                                            @click.prevent="sortLights('test_result')"
                                            :class="sortClass('test_result')"
                                        >
                                            Tested
                                        </th>
                                        <th
                                            class="th td td-na"
                                            @click.prevent="sortLights('not_accessible')"
                                            :class="sortClass('not_accessible')"
                                        >
                                            Not Accessible
                                        </th>
                                        <th>
                                        <!-- options -->
                                        </th>
                                    </tr>
                                </thead>
                                <draggable
                                    v-model="form.lights"
                                    tag="tbody"
                                    handle=".drag-handle"
                                >
                                    <tr
                                        v-for="(light, i) in form.lights"
                                        :key="i"
                                        :class="{'invalid' : isLightInvalid(light)}"
                                    >
                                        <td class="drag-handle-col">
                                            <span class="drag-handle">
                                                <i class="fas fa-arrows-alt-v" />
                                            </span>
                                        </td>
                                        <td class="td td-sw-no">
                                            {{ light.sw_no || "-" }}
                                        </td>
                                        <td class="td td-light-no">
                                            {{ light.light_no || "-" }}
                                        </td>
                                        <td class="td td-maintained text-center">
                                            {{ light.maintained ? "Y" : "N" }}
                                        </td>
                                        <td class="td td-type">
                                            <div class="light-type-display">
                                                <img
                                                    v-if="getLightTableImage(light)"
                                                    :src="getLightTableImage(light)"
                                                    class="light-type-display__image"
                                                    alt="Light type"
                                                >
                                                <span>{{ getLightTypeDisplay(light) }}</span>
                                            </div>
                                        </td>
                                        <td class="td td-light-location">
                                            <div class="light-location-lines">
                                                <div>
                                                    <strong>Light:</strong>
                                                    {{ light.light_location || "-" }}
                                                </div>
                                                <div>
                                                    <strong>Switch:</strong>
                                                    {{ light.switch_location || "-" }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="td td-high text-center">
                                            {{ light.high ? "Y" : "N" }}
                                        </td>
                                        <td class="td td-tested text-center">
                                            <span
                                                v-if="light.not_accessible"
                                                class="text-muted"
                                            >N/A</span>
                                            <div
                                                v-else
                                                class="light-test-buttons"
                                            >
                                                <label class="button-radio">
                                                    <input
                                                        v-model="light.test_result"
                                                        type="radio"
                                                        value="passed"
                                                        @click="toggleResult('passed', i)"
                                                    >
                                                    <span class="button-radio-text">P</span>
                                                </label>
                                                <label class="button-radio">
                                                    <input
                                                        v-model="light.test_result"
                                                        type="radio"
                                                        value="failed"
                                                        @click="toggleResult('failed', i)"
                                                    >
                                                    <span class="button-radio-text button-radio-text--failed">F</span>
                                                </label>
                                            </div>
                                        </td>
                                        <td class="td td-high text-center">
                                            {{ light.not_accessible ? "Y" : "N" }}
                                        </td>
                                        <td class="td td-buttons">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-primary mr-1"
                                                @click="openEditLightModal(i)"
                                            >
                                                <i class="fa fa-pencil-alt" />
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click="promptLightDeletion(i)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </draggable>
                                <tfoot>
                                    <tr>
                                        <td
                                            class="text-right"
                                            colspan="10"
                                        >
                                            <span
                                                v-if="form.lights"
                                                class="light-count"
                                            >Total Number of Maintained: {{ form.lights_maintained }}</span>
                                            <span
                                                v-if="form.lights"
                                                class="light-count"
                                            >Total Number of Non-Maintained: {{ form.lights_non_maintained }}</span>
                                            <button
                                                class="btn btn-info"
                                                type="button"
                                                @click="addSiteLights"
                                                :disabled="!form.site_id"
                                            >
                                                <i class="fa fa-download" />
                                                Add lights from site
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                type="button"
                                                @click="openAddLightModal"
                                            >
                                                <i class="fa fa-plus" /> Add Light
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                type="button"
                                                :disabled="form.lights.length === 0"
                                                @click="copyLight"
                                            >
                                                <i class="fa fa-copy" /> Copy Light
                                            </button>
                                            <button
                                                class="btn btn-primary"
                                                type="submit"
                                            >
                                                <i class="fa fa-save" /> Save
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <h5>Key:</h5>
                                    <ul>
                                        <li>T.S. No - Test Switch Number</li>
                                        <li>Li No - Light Number</li>
                                        <li>P - Passed</li>
                                        <li>F - Failed</li>
                                    </ul>
                                </div>
                                <div
                                    v-if="failedLightsByType.length"
                                    class="col-md-6 col-sm-12 d-flex justify-content-md-end"
                                >
                                    <div class="failed-lights-summary">
                                        <h5>Failed Lights by Type</h5>
                                        <table class="table table-sm failed-lights-summary__table">
                                            <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th class="text-center">
                                                        Count
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="(row, index) in failedLightsByType"
                                                    :key="index"
                                                >
                                                    <td class="p-2">
                                                        {{ row.type }}
                                                    </td>
                                                    <td class="text-center p-2">
                                                        {{ row.count }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="failedLightsByType.length > 1">
                                                <tr>
                                                    <td class="p-2">
                                                        <strong>Total</strong>
                                                    </td>
                                                    <td class="text-center p-2">
                                                        <strong>{{ form.lights_failed }}</strong>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="card"
                v-show="hasHighLights"
            >
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>High Access Lights</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="td-sw-no">
                                            Test Sw No.
                                        </th>
                                        <th class="td-light-no">
                                            Light No.
                                        </th>
                                        <th>Equipment Needed</th>
                                        <th>Height in Meters</th>
                                        <th>Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(light, index) in form.lights"
                                        :key="index"
                                        v-show="light.high"
                                    >
                                        <td class="td td-sw-no">
                                            <input
                                                type="text"
                                                v-model="light.sw_no"
                                                placeholder="Test Sw No"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-light-no">
                                            <input
                                                type="text"
                                                v-model="light.light_no"
                                                placeholder="Light No."
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-equipment">
                                            <select
                                                v-model="light.equipment_needed"
                                                name="light_equipment_needed[]"
                                                placeholder="Equipment Needed"
                                                class="form-control"
                                                :required="light.high"
                                            >
                                                <option>11-Tread - Step Ladder</option>
                                                <option>2 Section - Extension Ladder</option>
                                                <option>3 Section - Extension Ladder</option>
                                                <option>3 Section - A Frame Ladder</option>
                                                <option>Scissor Lift</option>
                                                <option>Cherry Picker</option>
                                                <option>Telescopic Ladders</option>
                                                <option>Stair Ladders</option>
                                            </select>
                                        </td>
                                        <td class="td td-height">
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                v-model="light.height"
                                                placeholder="Hight (m)"
                                                class="form-control"
                                            >
                                        </td>
                                        <td class="td td-comment">
                                            <input
                                                type="text"
                                                v-model="light.comment"
                                                placeholder="Comment"
                                                class="form-control"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Property Device Lighting Checks</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label>I feel the following areas are adequately covered by Emergency
                                            Lighting:</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="areas_covered"
                                            v-model="form.areas_covered"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="areas_covered"
                                            v-model="form.areas_covered"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="areas_covered"
                                            v-model="form.areas_covered"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="areas_covered"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>All escape routes covered</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escape_covered"
                                            v-model="form.escape_covered"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escape_covered"
                                            v-model="form.escape_covered"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escape_covered"
                                            v-model="form.escape_covered"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="escape_covered"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>The inside of each door</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_door"
                                            v-model="form.each_door"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_door"
                                            v-model="form.each_door"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_door"
                                            v-model="form.each_door"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="each_door"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Outside each final exit</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="final_exit"
                                            v-model="form.final_exit"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="final_exit"
                                            v-model="form.final_exit"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="final_exit"
                                            v-model="form.final_exit"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="final_exit"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Near changes of direction</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="changes_direction"
                                            v-model="form.changes_direction"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="changes_direction"
                                            v-model="form.changes_direction"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="changes_direction"
                                            v-model="form.changes_direction"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="changes_direction"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Near each intersection</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_intersection"
                                            v-model="form.each_intersection"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_intersection"
                                            v-model="form.each_intersection"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_intersection"
                                            v-model="form.each_intersection"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="each_intersection"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>At each change of floor level</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_floor"
                                            v-model="form.each_floor"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_floor"
                                            v-model="form.each_floor"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_floor"
                                            v-model="form.each_floor"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="each_floor"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Each staircase</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_staircase"
                                            v-model="form.each_staircase"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_staircase"
                                            v-model="form.each_staircase"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_staircase"
                                            v-model="form.each_staircase"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="each_staircase"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>At each call point</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_call_point"
                                            v-model="form.each_call_point"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_call_point"
                                            v-model="form.each_call_point"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_call_point"
                                            v-model="form.each_call_point"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="each_call_point"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>All fire fighting equipment</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_ffe"
                                            v-model="form.all_ffe"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_ffe"
                                            v-model="form.all_ffe"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_ffe"
                                            v-model="form.all_ffe"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="all_ffe"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Inside all disabled toilets</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="disabled_toilets"
                                            v-model="form.disabled_toilets"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="disabled_toilets"
                                            v-model="form.disabled_toilets"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="disabled_toilets"
                                            v-model="form.disabled_toilets"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="disabled_toilets"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Inside toilets with a floor area 8m2 or more</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="inside_toilets"
                                            v-model="form.inside_toilets"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="inside_toilets"
                                            v-model="form.inside_toilets"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="inside_toilets"
                                            v-model="form.inside_toilets"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="inside_toilets"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Outside and inside all lifts</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_lifts"
                                            v-model="form.all_lifts"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_lifts"
                                            v-model="form.all_lifts"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="all_lifts"
                                            v-model="form.all_lifts"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="all_lifts"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Escalators and moving walkways</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escalators"
                                            v-model="form.escalators"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escalators"
                                            v-model="form.escalators"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="escalators"
                                            v-model="form.escalators"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="escalators"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Plant rooms and electrical cupboards</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="plant_rooms"
                                            v-model="form.plant_rooms"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="plant_rooms"
                                            v-model="form.plant_rooms"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="plant_rooms"
                                            v-model="form.plant_rooms"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="plant_rooms"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Rooms with no natural lighting</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="no_natural_light"
                                            v-model="form.no_natural_light"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="no_natural_light"
                                            v-model="form.no_natural_light"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="no_natural_light"
                                            v-model="form.no_natural_light"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="no_natural_light"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>A minimum of 2 fittings per compartment</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fittings_per_compartment"
                                            v-model="form.fittings_per_compartment"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fittings_per_compartment"
                                            v-model="form.fittings_per_compartment"
                                            value="No"
                                        > No</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="fittings_per_compartment"
                                            v-model="form.fittings_per_compartment"
                                            value="N\A"
                                        > N/A</label>
                                        <error
                                            name="fittings_per_compartment"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Test Keys Needed - To Carry Out Monthly Test</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table">
                                <tbody>
                                    <tr
                                        v-for="(key, index) in form.test_keys"
                                        :key="index"
                                    >
                                        <td>
                                            <select
                                                v-model="key.value"
                                                class="form-control"
                                            >
                                                <option :value="null">
                                                    Select Key
                                                </option>
                                                <option
                                                    v-for="k in testKeys"
                                                    :key="k.id"
                                                    :value="k.name"
                                                >
                                                    {{ k.name }}
                                                </option>
                                            </select>
                                        </td>
                                        <td class="text-right">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-danger"
                                                @click="removeTestKey(index)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td
                                            class="text-right"
                                            colspan="2"
                                        >
                                            <button
                                                class="btn btn-primary"
                                                @click.prevent="addTestKey"
                                            >
                                                Add Key
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <table class="table">
                                <tr>
                                    <td>
                                        <label>Would the customer like any keys to carry out the Monthly
                                            Checks?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="customer_keys"
                                            v-model="form.customer_keys"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="customer_keys"
                                            v-model="form.customer_keys"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="customer_keys"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Final Checks</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label>Does the customer have an automatic test system fitted on site?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="auto_test_on_site"
                                            v-model="form.auto_test_on_site"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="auto_test_on_site"
                                            v-model="form.auto_test_on_site"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="auto_test_on_site"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>After test, each luminaire charging indicator operates correctly?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_luminaire"
                                            v-model="form.each_luminaire"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="each_luminaire"
                                            v-model="form.each_luminaire"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="areas_covered"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Lighting System returned to normal state?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="system_returned"
                                            v-model="form.system_returned"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="system_returned"
                                            v-model="form.system_returned"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="system_returned"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Signage</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label>Are all fire action signs present and installed to BS 5499?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="signage_present"
                                            v-model="form.signage_present"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="signage_present"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Are all non-photo luminescent signs covered by emergency
                                            lighting?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="non_photo_signs"
                                            v-model="form.non_photo_signs"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="non_photo_signs"
                                            v-model="form.non_photo_signs"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="non_photo_signs"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Logs Book</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <tr>
                                    <td>
                                        <label>Has the Emergency Lighting log book been completed?</label>
                                    </td>
                                    <td class="text-right">
                                        <select
                                            v-model="form.log_book_complete"
                                            name="log_book_complete"
                                            id="log_book_complete"
                                            class="form-control"
                                        >
                                            <option>Yes</option>
                                            <option>No</option>
                                            <option>No Log Book Available</option>
                                            <option>R.P Not on Site</option>
                                            <option>Non Manned</option>
                                            <option>Would like log book emailed</option>
                                        </select>
                                        <error
                                            name="log_book_complete"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <label>Have all recommendations, outstanding issues and non-complances been
                                            recorded and reported to the responsible person?</label>
                                    </td>
                                    <td class="text-right">
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recommendations_recorded"
                                            v-model="form.recommendations_recorded"
                                            value="Yes"
                                        > Yes</label>
                                        <label class="form-check-label"><input
                                            type="radio"
                                            name="recommendations_recorded"
                                            v-model="form.recommendations_recorded"
                                            value="No"
                                        > No</label>
                                        <error
                                            name="recommendations_recorded"
                                            :errors="errors"
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Observations and Recommendations as per BS 5266</h3>
                            <textarea
                                name="recommendations"
                                id="recommendations"
                                cols="30"
                                rows="10"
                                class="form-control"
                                placeholder="Type observations and recommendations here..."
                                v-model="form.recommendations"
                            />
                            <error
                                name="recommendations"
                                :errors="errors"
                            />
                            <button
                                class="btn btn-info"
                                type="button"
                                @click.prevent="fillRecommendations()"
                            >
                                Fill Recommendations
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <h3>Notes</h3>
                            <textarea
                                name="Notes"
                                id="Notes"
                                cols="30"
                                rows="10"
                                class="form-control"
                                v-model="form.notes"
                                placeholder="Type Notes here..."
                            />
                            <error
                                name="notes"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <form-photos :form-id="form.id" />

            <div class="card">
                <div class="card-body">
                    <h3>Signoff</h3>
                    <p>
                        I declare that I am a competent person (CP) in Emergency lighting system maintenance. All
                        equipment returned to normal Serviced according to BS 5266
                    </p>
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                name="engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="engineer_sign_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                name="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <engineer-notes
                v-if="form.site_id"
                :site-id="form.site_id"
            />

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id"
                                :to="{name: 'office.forms.new', query: {elighting_form: form.id, type: 'elighting_certificate'}}"
                            >
                                <i class="fa fa-copy" /> Create Certificate
                            </router-link>

                            <router-link
                                :to="{name: 'engineer.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'engineer.forms.edit'"
                            >
                                <i class="fa fa-chevron-left" /> Back to Job
                            </router-link>

                            <router-link
                                :to="{name: 'office.jobs.show', params: {id: form.job_id}}"
                                class="btn btn-info"
                                v-if="$route.name === 'office.forms.edit'"
                            >
                                <i class="fa fa-briefcase" /> View Job
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <e-lighting-light-modal
            ref="lightModal"
            @save="saveLightFromModal"
            @request-delete="promptLightDeletion"
        />

        <b-modal
            ref="deleteLightModal"
            title="Delete Light"
            @ok="confirmDeleteLight"
        >
            Are you sure you want to delete this light?
        </b-modal>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import Service from "../../services/FormService";
import * as moment from "moment";
import SignatureComponent from "../SignatureComponent.vue";
import AuthService from "../../services/AuthService";
import FormService from "../../services/FormService";
import JobService from "../../services/JobService";
import UsersService from "../../services/UsersService";
import SiteService from "../../services/SitesService";
import UsesErrors from "../../mixins/UsesErrors";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import Sortables from "../../mixins/Sortables";
import draggable from "vuedraggable";
import JobInfo from "./parts/JobInfoComponent";
import EngineerNotes from "./parts/EngineerNotesComponent";
import ProductsService from "../../services/ProductsService";
import FormPhotos from "./parts/FormPhotosComponent.vue";
import DurationSelectComponent from "./parts/DurationSelectComponent.vue";
import UploadService from "../../services/UploadService";
import ELightingLightModal from "./parts/ELightingLightModal.vue";
import UsesElightingLights from "../../mixins/UsesElightingLights";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";

export default {
    components: {
        DurationSelectComponent,
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
        signature: SignatureComponent,
        draggable,
        JobInfo,
        EngineerNotes,
        FormPhotos,
        ELightingLightModal,
    },
    mixins: [UsesErrors, UsesInfoMessage, Sortables, UsesElightingLights, UsesFormRouteQuery],
    props: {
        formId: {
            default: () => null,
        },
    },
    data: function () {
        return {
            officeStaff: [],
            changed: false,
            sites: [],
            customerSignature: null,
            jobs: [],
            form: {
                type: "elighting",
                customer: {
                    company_name: "",
                },
                job_id: null,
                site_id: "",
                lights: [],
                engineer_sign_date: moment(),
                customer_sign_date: moment(),
                lights_maintained: 0,
                lights_non_maintained: 0,
                lights_failed: 0,
            },
            materials: [],
            token: null,
            site_lights: [],
            testKeys: [],
            pendingDeleteLightIndex: null,
        };
    },
    computed: {
        canDelete() {
            return (
                AuthService.user.admin_access || AuthService.user.office_access
            );
        },

        highLights() {
            if (!this.form.lights) {
                return [];
            }
            return this.form.lights.filter((l) => l.high);
        },

        hasHighLights() {
            return this.highLights.length > 0;
        },

        failedLightsByType() {
            if (!this.form.lights || !this.form.lights.length) {
                return [];
            }

            const groups = {};
            this.form.lights.forEach((light) => {
                if (light.test_result !== "failed") {
                    return;
                }
                const typeLabel = this.getLightTypeDisplay(light);
                if (!groups[typeLabel]) {
                    groups[typeLabel] = 0;
                }
                groups[typeLabel]++;
            });

            return Object.keys(groups)
                .sort((a, b) => a.localeCompare(b))
                .map((type) => ({
                    type: type,
                    count: groups[type],
                }));
        },
    },
    mounted: function () {
        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then((res) => {
                this.form.doc_no = res.data;
            });

            this.form.engineer_sign_date = moment();
            this.form.customer_sign_date = moment();
        }

        this.getOfficeStaff();
        this.loadTestKeys();

        if (!this.form.engineer_sign_name && AuthService.user.engineer_access) {
            this.form.engineer_sign_name = AuthService.user.name;
            this.engineerNameChanged();
        }
    },
    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id)
                .then(
                    (res) => {
                        this.form = res.data;
                        if (
                            this.form.job !== null &&
                            typeof this.form.job.invoiced_at !== "undefined"
                        ) {
                            this.form.job.invoiced_at = moment(
                                this.form.job.invoiced_at
                            );
                            this.form.job.invoiced_at = moment(
                                this.form.job.invoiced_at
                            );
                        }
                        //TODO fix loading in date as moment
                        if (res.data.engineer_sign_date) {
                            this.form.engineer_sign_date = moment(
                                res.data.engineer_sign_date
                            );
                        } else {
                            this.form.engineer_sign_date = moment();
                        }
                        if (res.data.customer_sign_date) {
                            this.form.customer_sign_date = moment(
                                res.data.customer_sign_date
                            );
                        } else {
                            this.form.customer_sign_date = moment();
                        }
                        this.getJobs();
                        this.validateLightsArray();
                        this.form.lights = this.normalizeLightsCollection(
                            this.form.lights,
                            {markAsExisting: true}
                        );
                        this.lightsChanged();
                    },
                    () => {
                        this.setErrorMessage("Could not load form");
                    }
                )
                .then(() => {
                    this.clearLoading();
                });
        },
        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            this.loadTestKeys();
            if (customer && customer.sites) {
                if (
                    !customer.sites
                        .map((site) => site.id)
                        .includes(this.form.site_id)
                ) {
                    this.form.site_id = "";
                }
            } else {
                this.form.site_id = "";
            }
            this.siteChanged();
            this.getJobs();
        },
        siteChanged: function () {
            this.loadSiteFormFields();
            this.loadSiteLights();
            this.validateLightsArray();
            if (this.form.lights.length === 0) {
                this.addSiteLights();
            }
        },
        loadSiteFormFields: function () {
            if (
                typeof this.form.site_id === "undefined" ||
                !this.form.site_id
            ) {
                return;
            }

            SiteService.get(this.form.site_id).then((res) => {
                if (res.data.form_fields) {
                    const siteServiceTime = res.data.form_fields.find(f => f.name === 'elighting_service_time');
                    this.form.elighting_service_time = this.form.elighting_service_time || siteServiceTime ? siteServiceTime.value : '';
                }
            });
        },
        onJobLoadedFromRoute(jobData) {
            this.getJobs();
            this.customerChanged(jobData.customer);
        },
        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                () => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },
        saveForm: function () {
            const errorRows = this.form.lights.filter((light) =>
                this.isLightInvalid(light)
            );
            if (errorRows.length > 0) {
                window.alert(
                    `Error: ${errorRows.length} light(s) have invalid or missing required fields`
                );
                document.getElementById("lights-table").scrollIntoView();
                return;
            }

            this.setSaving();
            if (
                this.$refs.engineerSignature &&
                !this.$refs.engineerSignature.isEmpty()
            ) {
                this.form.engineer_signature =
                    this.$refs.engineerSignature.toPng();
            }
            if (
                this.$refs.customerSignature &&
                !this.$refs.customerSignature.isEmpty()
            ) {
                this.form.customer_signature =
                    this.$refs.customerSignature.toPng();
            }
            this.form.materials = this.materials;
            this.lightsChanged();

            let data = {...this.form};
            delete data["customer"];
            delete data["site"];
            delete data["job"];
            delete data["data"];
            data.lights = this.serializeLightsForSave(data.lights);

            if (this.form.id) {
                Service.update(data).then(
                    (res) => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit("formSaved", res.data);
                    },
                    (err) => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                Service.create(data).then(
                    (res) => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes("engineer/")) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id,
                                },
                            });
                        }
                    },
                    (err) => {
                        this.clearSaving();
                        this.setErrorMessage("Could not save form");
                        this.captureRequestErrors(err);
                    }
                );
            }
        },
        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                Service.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        // TODO: Redirect to relavant page
                        this.$router.push({name: "office.forms.search"});
                    },
                    (error) => {
                        this.setErrorMessage("Could not delete this form");
                        console.error(error);
                    }
                );
            }
        },

        removeLight: function (index) {
            this.promptLightDeletion(index);
        },

        addLight: function () {
            if (typeof this.form.lights === "undefined") {
                this.form.lights = [];
            }
            this.openAddLightModal();
        },

        copyLight: function () {
            if (typeof this.form.lights === "undefined") {
                this.form.lights = [];
            }
            if (this.form.lights.length === 0) {
                return;
            }
            const last = this.normalizeLight(
                this.form.lights[this.form.lights.length - 1]
            );
            last._is_existing_light = false;
            this.form.lights.push({...last});
            this.$forceUpdate();
            this.lightsChanged();
        },
        openAddLightModal() {
            this.$refs.lightModal.open({
                mode: "add",
                light: {},
                index: null,
            });
        },
        openEditLightModal(index) {
            this.$refs.lightModal.open({
                mode: "edit",
                light: this.form.lights[index],
                index,
            });
        },
        saveLightFromModal(payload) {
            const normalizedLight = this.normalizeLight(payload.light);
            normalizedLight._is_existing_light = false;
            if (payload.mode === "edit" && payload.index !== null) {
                this.form.lights.splice(payload.index, 1, normalizedLight);
            } else {
                this.form.lights.push(normalizedLight);
            }
            this.$forceUpdate();
            this.lightsChanged();
        },
        promptLightDeletion(index) {
            this.pendingDeleteLightIndex = index;
            this.$refs.deleteLightModal.show();
        },
        confirmDeleteLight() {
            const index = this.pendingDeleteLightIndex;
            this.pendingDeleteLightIndex = null;
            if (index === null || typeof this.form.lights[index] === "undefined") {
                return;
            }
            const light = this.form.lights[index];
            this.deleteLightImageIfUnreferenced(light.photo_url, index).then(() => {
                this.form.lights.splice(index, 1);
                this.$forceUpdate();
                this.lightsChanged();
            });
        },
        deleteLightImageIfUnreferenced(photoUrl, deletingIndex) {
            if (!photoUrl) {
                return Promise.resolve();
            }
            const matches = this.form.lights.filter((light, index) => {
                if (index === deletingIndex) {
                    return false;
                }
                return light && light.photo_url === photoUrl;
            });
            if (matches.length > 0) {
                return Promise.resolve();
            }
            return UploadService.delete(photoUrl).catch(() => {
            });
        },

        saveInvoiceDetails: function () {
            JobService.update(this.form.job).then(
                () => {
                    this.setInfoMessage("Invoice details saved");
                },
                () => {
                    this.setErrorMessage(
                        "Error: Could not save invoice details"
                    );
                }
            );
        },

        getOfficeStaff: function () {
            return new Promise((fulfill, reject) => {
                UsersService.officeStaff().then(
                    (xhr) => {
                        this.officeStaff = xhr.data;
                        fulfill(xhr);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },

        engineerNameChanged: function () {
            var name = this.form.engineer_sign_name;
            var signature = "";
            var nameArray = name.split(" ");
            if (nameArray.length > 1) {
                signature += nameArray[0][0];
                signature += nameArray[1];
            } else {
                signature = name;
            }
            if (signature) {
                this.form.engineer_signature_text = signature;
            }
        },

        forceUpdate: function () {
            this.$forceUpdate();
        },

        lightsChanged: function () {
            this.form.lights_maintained = 0;
            this.form.lights_non_maintained = 0;
            this.form.lights_failed = 0;
            if (this.form.lights) {
                this.form.lights.forEach((light) => {
                    if (light.maintained) {
                        this.form.lights_maintained++;
                    } else {
                        this.form.lights_non_maintained++;
                    }
                    if (light.test_result === "failed") {
                        this.form.lights_failed++;
                    }
                });
            }
        },

        fillRecommendations: function () {
            let r = [];
            const f = this.form;

            if (f.recommendations) {
                const confirm = window.confirm(
                    "This will overwrite current recommendations, is that OK?"
                );
                if (!confirm) {
                    return;
                }
            }

            if (f.lights && f.lights.length) {
                var failLights = f.lights.filter(
                    (l) => l.test_result === "failed"
                );
                if (failLights.length > 0) {
                    r.push(
                        "Light(s) have failed the annual battery discharged test -  Remidial works needed to be carried out."
                    );
                }
            }

            if (f.risk_assessment === "No") {
                r.push(
                    "No Fire Risk Assessment on site Or review over 12months ago."
                );
            }

            if (f.escape_covered === "No") {
                r.push(
                    "All escape routes should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_door === "No") {
                r.push(
                    "All inside of doors should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.final_exit === "No") {
                r.push(
                    "Outside each final exit should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.changes_direction === "No") {
                r.push(
                    "All near changes of direction should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_intersection === "No") {
                r.push(
                    "Near each intersection should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_floor === "No") {
                r.push(
                    "At each change of floor level should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_staircase === "No") {
                r.push(
                    "Each staircase should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_call_point === "No") {
                r.push(
                    "Each call point should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.all_ffe === "No") {
                r.push(
                    "All fire fighting equipment should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.disabled_toilets === "No") {
                r.push(
                    "Inside all disabled toilets should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.inside_toilets === "No") {
                r.push(
                    "Inside toilets with a floor area 8m2 or more should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.all_lifts === "No") {
                r.push(
                    "Outside and inside all lifts should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.escalators === "No") {
                r.push(
                    "Escalators and moving walkways should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.plant_rooms === "No") {
                r.push(
                    "Plant rooms and electrical cupboards should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.no_natural_light === "No") {
                r.push(
                    "Rooms with no natural lighting should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.fittings_per_compartment === "No") {
                r.push(
                    "A minimum of 2 fittings per compartment should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.each_luminaire === "No") {
                r.push(
                    "After test, Each luminaire charging indicator operates correctly?"
                );
            }

            if (f.signage_present === "No") {
                r.push("Install fire action signs as per BS 5499.");
            }

            if (f.non_photo_signs === "No") {
                r.push(
                    "All safety signs should be covered by Emergency Lighting, additional recommended."
                );
            }

            if (f.log_book_complete === "No") {
                r.push("No Log book available please Update site Log book.");
            }

            this.form.recommendations = r.join("\n\n");
            this.$forceUpdate();
        },

        loadPreviousForm: function () {
            if (this.form.site_id && this.form.type) {
                FormService.loadPrevious(
                    this.form.type,
                    this.form.site_id,
                    this.form.id
                ).then((res) => {
                    if (this.form.lights.length < 1 && res.data.lights) {
                        this.form.lights = this.normalizeLightsCollection(
                            res.data.lights
                        );
                        this.lightsChanged();
                        this.$forceUpdate();
                    }
                });
            }
        },

        loadSiteLights: function () {
            if (
                typeof this.form.site_id === "undefined" ||
                !this.form.site_id
            ) {
                this.site_lights = [];
                this.lightsChanged();
                return;
            }

            SiteService.get(this.form.site_id).then((res) => {
                this.site_lights = this.normalizeLightsCollection(
                    res.data.lights,
                    {markAsExisting: true}
                );
                this.lightsChanged();
            });
        },

        addSiteLights: function () {
            this.validateLightsArray();
            if (this.site_lights.length > 0 && this.form.lights.length > 0) {
                var confirm = window.confirm(
                    "This will override lights added to this form, continue?"
                );
                if (!confirm) {
                    return;
                }

                this.form.lights = this.normalizeLightsCollection(
                    this.site_lights,
                    {markAsExisting: true}
                );
            } else {
                this.form.lights = this.normalizeLightsCollection(
                    this.site_lights,
                    {markAsExisting: true}
                );
            }
            this.lightsChanged();
            this.$forceUpdate();
        },

        validateLightsArray: function () {
            if (typeof this.form.lights === "undefined") {
                this.form.lights = [];
            }

            if (typeof this.site_lights === "undefined") {
                this.site_lights = [];
            }
        },

        toggleResult(result, i) {
            const light = this.form.lights[i];
            if (light.test_result === result) {
                this.$set(this.form.lights[i], "test_result", null);
            }
            this.$nextTick(() => {
                this.lightsChanged();
            });
        },

        sortLights(key) {
            this.form.lights = this.sortItems(key, this.form.lights);
            this.$forceUpdate();
        },

        loadTestKeys() {
            ProductsService.index({
                category_name: "Emergency Lighting - Test Key",
                customer_id: this.form.customer_id,
            }).then((res) => {
                this.testKeys = res.data;
            });
        },
        addTestKey() {
            if (!this.form.test_keys) {
                this.form.test_keys = [];
            }
            this.form.test_keys.push({
                value: null,
            });
            this.$forceUpdate();
        },
        removeTestKey(index) {
            this.form.test_keys.splice(index, 1);
            this.$forceUpdate();
        },
        handleDeviceNotAccessible(i) {
            const light = this.form.lights[i];
            if (light.not_accessible) {
                light.tested = false;
                light.test_result = null;
            }
            this.form.lights[i] = light;
            this.$forceUpdate();
        },
    },
};
</script>
<style lang="scss">
.lighting-table {
    .th {
        vertical-align: text-top;
    }

    tr.invalid {
        background: #ffd3d3;
    }

    .td {
        padding: 5px 2px;

        &-sw-no {
            width: 4rem;
        }

        &-light-no {
            width: 4rem;
        }

        &-maintained {
            width: 3rem;
            text-align: center;

            input {
                width: auto;
                display: inline-block;
            }
        }

        &-type {
            width: 9rem;
        }

        &-buttons {
            width: 5.5rem;
            text-align: center;
        }

        &-tested {
            width: 5.5rem;
            text-align: center;
        }

        &-na {
            width: 7rem;
            text-align: center;
        }
    }

    .light-test-buttons {
        display: inline-flex;
        gap: 5px;
        justify-content: center;
    }

    .button-radio {
        display: inline-block;
        margin: 0;

        input {
            display: none;
        }

        &-text {
            display: block;
            padding: 4px 8px;
            min-width: 1.75rem;
            background: #eeeeee;
            border-radius: 3px;
            text-align: center;
            cursor: pointer;
            font-weight: 600;
            line-height: 1.2;

            &:hover {
                background: #d5d5d5;
            }
        }

        input[type="radio"]:checked + .button-radio-text {
            background: #89ca70;
            color: #ffffff;

            &:hover {
                background: #7ab862;
            }
        }

        input[type="radio"]:checked + .button-radio-text--failed {
            background: #dc3545;
            color: #ffffff;

            &:hover {
                background: #c82333;
            }
        }
    }
}

.light-count {
    margin-right: 1em;
    text-decoration: underline;
}

.light-type-display {
    display: flex;
    align-items: center;
    gap: 0.4rem;

    &__image {
        width: 22px;
        height: 22px;
        object-fit: cover;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        background: #fff;
    }
}

.light-location-lines {
    line-height: 1.3;
}

.failed-lights-summary {
    margin-top: 1.5rem;
    width: 100%;

    @media (min-width: 768px) {
        margin-top: 0;
    }

    &__table {
        width: 100%;
        margin-bottom: 0;
    }
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/ELightingFormComponent.vue